export default "__VITE_PUBLIC_ASSET__0198cb51__"